import e, { useRef as r, useEffect as t, createContext as n, forwardRef as o, useState as a, useContext as c } from "react";
import { createPortal as u } from "react-dom";
import i from "prop-types";
var l = "undefined" != typeof globalThis ? globalThis : "undefined" != typeof window ? window : "undefined" != typeof global ? global : "undefined" != typeof self ? self : {};

function s(e, r) {
  return e(r = {
    exports: {}
  }, r.exports), r.exports;
}

var f = s(function (e) {
  !function (r) {
    var t = function (e, r, n) {
      if (!i(r) || s(r) || f(r) || p(r) || u(r)) return r;
      var o,
          a = 0,
          c = 0;
      if (l(r)) for (o = [], c = r.length; a < c; a++) o.push(t(e, r[a], n));else for (var d in o = {}, r) Object.prototype.hasOwnProperty.call(r, d) && (o[e(d, n)] = t(e, r[d], n));
      return o;
    },
        n = function (e) {
      return d(e) ? e : (e = e.replace(/[\-_\s]+(.)?/g, function (e, r) {
        return r ? r.toUpperCase() : "";
      })).substr(0, 1).toLowerCase() + e.substr(1);
    },
        o = function (e) {
      var r = n(e);
      return r.substr(0, 1).toUpperCase() + r.substr(1);
    },
        a = function (e, r) {
      return function (e, r) {
        var t = (r = r || {}).separator || "_",
            n = r.split || /(?=[A-Z])/;
        return e.split(n).join(t);
      }(e, r).toLowerCase();
    },
        c = Object.prototype.toString,
        u = function (e) {
      return "function" == typeof e;
    },
        i = function (e) {
      return e === Object(e);
    },
        l = function (e) {
      return "[object Array]" == c.call(e);
    },
        s = function (e) {
      return "[object Date]" == c.call(e);
    },
        f = function (e) {
      return "[object RegExp]" == c.call(e);
    },
        p = function (e) {
      return "[object Boolean]" == c.call(e);
    },
        d = function (e) {
      return (e -= 0) == e;
    },
        y = function (e, r) {
      var t = r && "process" in r ? r.process : r;
      return "function" != typeof t ? e : function (r, n) {
        return t(r, e, n);
      };
    },
        h = {
      camelize: n,
      decamelize: a,
      pascalize: o,
      depascalize: a,
      camelizeKeys: function (e, r) {
        return t(y(n, r), e);
      },
      decamelizeKeys: function (e, r) {
        return t(y(a, r), e, r);
      },
      pascalizeKeys: function (e, r) {
        return t(y(o, r), e);
      },
      depascalizeKeys: function () {
        return this.decamelizeKeys.apply(this, arguments);
      }
    };

    e.exports ? e.exports = h : r.humps = h;
  }(l);
}).decamelize,
    p = s(function (e) {
  function r() {
    return e.exports = r = Object.assign || function (e) {
      for (var r = 1; r < arguments.length; r++) {
        var t = arguments[r];

        for (var n in t) Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
      }

      return e;
    }, r.apply(this, arguments);
  }

  e.exports = r;
});

var d = function (e) {
  if (Array.isArray(e)) return e;
};

var y = function (e, r) {
  if ("undefined" != typeof Symbol && Symbol.iterator in Object(e)) {
    var t = [],
        n = !0,
        o = !1,
        a = void 0;

    try {
      for (var c, u = e[Symbol.iterator](); !(n = (c = u.next()).done) && (t.push(c.value), !r || t.length !== r); n = !0);
    } catch (e) {
      o = !0, a = e;
    } finally {
      try {
        n || null == u.return || u.return();
      } finally {
        if (o) throw a;
      }
    }

    return t;
  }
};

var h = function (e, r) {
  (null == r || r > e.length) && (r = e.length);

  for (var t = 0, n = new Array(r); t < r; t++) n[t] = e[t];

  return n;
};

var v = function (e, r) {
  if (e) {
    if ("string" == typeof e) return h(e, r);
    var t = Object.prototype.toString.call(e).slice(8, -1);
    return "Object" === t && e.constructor && (t = e.constructor.name), "Map" === t || "Set" === t ? Array.from(e) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? h(e, r) : void 0;
  }
};

var m = function () {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
};

var b = function (e, r) {
  return d(e) || y(e, r) || v(e, r) || m();
};

var g = function (e, r) {
  if (null == e) return {};
  var t,
      n,
      o = {},
      a = Object.keys(e);

  for (n = 0; n < a.length; n++) t = a[n], r.indexOf(t) >= 0 || (o[t] = e[t]);

  return o;
};

var S = function (e, r) {
  if (null == e) return {};
  var t,
      n,
      o = g(e, r);

  if (Object.getOwnPropertySymbols) {
    var a = Object.getOwnPropertySymbols(e);

    for (n = 0; n < a.length; n++) t = a[n], r.indexOf(t) >= 0 || Object.prototype.propertyIsEnumerable.call(e, t) && (o[t] = e[t]);
  }

  return o;
};

var w = n(null);

function O(e) {
  var r = e.root,
      t = e.children;
  return u(t, r);
}

function j(n) {
  var c = o(function (o, c) {
    var u,
        i,
        l = o.mode,
        s = o.delegatesFocus,
        f = o.styleSheets,
        d = o.ssr,
        y = o.children,
        h = S(o, ["mode", "delegatesFocus", "styleSheets", "ssr", "children"]),
        v = (i = r((u = c) && u.current), t(function () {
      u && (u.current = i.current);
    }, [u]), i),
        m = a(null),
        g = b(m, 2),
        j = g[0],
        x = g[1],
        z = "node_".concat(l).concat(s);
    return t(function () {
      if (v.current) try {
        if ("function" == typeof c && c(v.current), d) {
          var e = v.current.shadowRoot;
          return void x(e);
        }

        var r = v.current.attachShadow({
          mode: l,
          delegatesFocus: s
        });
        f.length > 0 && (r.adoptedStyleSheets = f), x(r);
      } catch (e) {
        !function (e) {
          var r = e.error,
              t = e.styleSheets,
              n = e.root;

          switch (r.name) {
            case "NotSupportedError":
              t.length > 0 && (n.adoptedStyleSheets = t);
              break;

            default:
              throw r;
          }
        }({
          error: e,
          styleSheets: f,
          root: j
        });
      }
    }, [c, v, f]), e.createElement(e.Fragment, null, e.createElement(n.tag, p({
      key: z,
      ref: v
    }, h), (j || d) && e.createElement(w.Provider, {
      value: j
    }, d ? e.createElement("template", {
      shadowroot: "open"
    }, n.render({
      root: j,
      ssr: d,
      children: y
    })) : e.createElement(O, {
      root: j
    }, n.render({
      root: j,
      ssr: d,
      children: y
    })))));
  });
  return c.propTypes = {
    mode: i.oneOf(["open", "closed"]),
    delegatesFocus: i.bool,
    styleSheets: i.arrayOf(i.instanceOf(globalThis.CSSStyleSheet)),
    ssr: i.bool,
    children: i.node
  }, c.defaultProps = {
    mode: "open",
    delegatesFocus: !1,
    styleSheets: [],
    ssr: !1,
    children: null
  }, c;
}

O.propTypes = {
  root: i.object.isRequired,
  children: i.node
}, O.defaultProps = {
  children: null
};
var x = new Map();

function z() {
  return c(w);
}

function E() {
  var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {},
      r = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : "core",
      t = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : function (e) {
    return e.children;
  };
  return new Proxy(e, {
    get: function (e, n) {
      var o = f(n, {
        separator: "-"
      }),
          a = "".concat(r, "-").concat(o);
      return x.has(a) || x.set(a, j({
        tag: o,
        render: t
      })), x.get(a);
    }
  });
}

var A = E();
export default A;
export { E as createProxy, z as useShadowRoot };